export default __webpack_public_path__ + "static/media/04.82f30452.jpg";